<style scoped lang="scss">
  .back img{
    width:30px;
    position: fixed;
    top:10px;
    left:10px;
    z-index: 2;
  }
</style>
<template>
  <div class="back">
    <img src="@/assets/images/mobile/icon_back.png" @click="goBack">
  </div>
</template>

<script>
export default {
  name: 'qk-back',
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/back.vue